import { render, staticRenderFns } from "./phone-number.vue?vue&type=template&id=2dfa56ba&scoped=true"
import script from "./phone-number.vue?vue&type=script&lang=js"
export * from "./phone-number.vue?vue&type=script&lang=js"
import style0 from "./phone-number.vue?vue&type=style&index=0&id=2dfa56ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa56ba",
  null
  
)

export default component.exports